import React from 'react';

import { PaperClipOutlined } from '@ant-design/icons';
import { Form, Upload } from 'antd';
import styled from 'styled-components';

import Button from 'components/lib/Button';

import { getUploadFileList } from './helpers';

const Attachments = styled.div`
  grid-column: 1 / -1;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

const AttachButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
`;

type Props = {
  beforeUpload: (file: File) => false | typeof Upload.LIST_IGNORE;
};

const EditShopRequestCommunicationLogUploadField = ({ beforeUpload }: Props) => (
  <Attachments>
    <Form.Item name="files" valuePropName="fileList" getValueFromEvent={getUploadFileList}>
      <Upload multiple beforeUpload={beforeUpload}>
        <AttachButton>
          <PaperClipOutlined />
          Attach Files
        </AttachButton>
      </Upload>
    </Form.Item>
  </Attachments>
);

export default EditShopRequestCommunicationLogUploadField;
